export default "__VITE_ASSET__Ny$bSfOt__"